import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
} from "chart.js"

Chart.register(LineController, LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend)

// Line chart: X-axis = hours, Y-axis = visits, one line per weekday (day×hour).
// data-peak-hours-chart-labels-value='["00:00","01:00",...]'
// data-peak-hours-chart-datasets-value='[{"label":"Monday","data":[...]}, ...]'
export default class extends Controller {
  static values = {
    labels: Array,
    datasets: Array,
    hourLabel: { type: String, default: "Hour" },
    visitsLabel: { type: String, default: "Visits" },
  }

  connect() {
    const canvas = this.element.querySelector("canvas") || this.element
    const colors = [
      "#3b82f6", "#22c55e", "#f59e0b", "#ef4444", "#8b5cf6", "#ec4899", "#06b6d4",
    ]

    this.chart = new Chart(canvas.getContext("2d"), {
      type: "line",
      data: {
        labels: this.labelsValue,
        datasets: this.datasetsValue.map((ds, i) => ({
          label: ds.label,
          data: ds.data,
          borderColor: colors[i % colors.length],
          backgroundColor: colors[i % colors.length] + "20",
          borderWidth: 2,
          fill: false,
          tension: 0.2,
          pointRadius: 4,
          pointBackgroundColor: colors[i % colors.length],
          pointBorderColor: "#fff",
          pointBorderWidth: 1,
        })),
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: "index",
          intersect: false,
        },
        plugins: {
          legend: { position: "top" },
          tooltip: {
            callbacks: {
              label: (ctx) => {
                const count = ctx.parsed.y
                return ` ${ctx.dataset.label}: ${count} ${this.visitsLabelValue}`
              },
            },
          },
        },
        scales: {
          x: {
            title: { display: true, text: this.hourLabelValue },
            ticks: { maxRotation: 45, autoSkip: true, maxTicksLimit: 12 },
          },
          y: {
            beginAtZero: true,
            title: { display: true, text: this.visitsLabelValue },
            ticks: { stepSize: 1 },
          },
        },
      },
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
